import { defineComponent as _defineComponent } from 'vue'
import SingleOwnerOutstandingFeesListing from './SingleOwnerOutstandingFeesListing.vue';
import SingleOwnerOutstandingFeesHeader from './SingleOwnerOutstandingFeesHeader.vue';
import ListBlock from 'ah-common-lib/src/common/components/listing/ListBlock.vue';
import { computed, ref } from 'vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleOwnerOutstandingFeesBlock',
  props: {
    userType: { default: 'client' },
    clientOrPartnerId: null
  },
  setup(__props: any, { expose }) {

const props = __props as { userType: 'client' | 'partner', clientOrPartnerId?: string };



const feeList = ref<InstanceType<typeof SingleOwnerOutstandingFeesListing> | null>(null);

const onBehalfOfClient = useOnBehalfOf();

const defaultSortAndPageParams = { sort: 'createdAt', sortDirection: 'DESC' };

const ownerId = computed(() => props.clientOrPartnerId || onBehalfOfClient.value?.id);

function loadData() {
  feeList.value!.loadData();
}

expose({ loadData });

return { __sfc: true,props, feeList, onBehalfOfClient, defaultSortAndPageParams, ownerId, loadData, SingleOwnerOutstandingFeesListing, SingleOwnerOutstandingFeesHeader, ListBlock }
}

})